module.exports = __webpack_public_path__ + "img/Slide5.7beecc0c.png";